import { render, staticRenderFns } from "./ModaNumBillComponent.vue?vue&type=template&id=6eb2ccc8"
import script from "./ModaNumBillComponent.vue?vue&type=script&lang=js"
export * from "./ModaNumBillComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports